webpackJsonp([62],{

/***/ "QM3b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-messages_161549fb1f264612d022f8feca82b4d0.html";

/***/ }),

/***/ "usqb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubscriptionMessages = (function () {
    SubscriptionMessages.$inject = ["subscriptionMessageSvc"];
    function SubscriptionMessages(subscriptionMessageSvc) {
        this.subscriptionMessageSvc = subscriptionMessageSvc;
    }
    return SubscriptionMessages;
}());
angular.module('animatronApp.SubscriptionMessages', [])
    .component('subscriptionMessages', {
    controller: SubscriptionMessages,
    templateUrl: __webpack_require__("QM3b")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/62-c7c98a0cc108ea8b91f3.min.js